// assets/js/references-filters.js

(function () {
  function slugify(label) {
    return label
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // vire accents
      .replace(/[^a-z0-9]+/g, '-')                     // espaces -> -
      .replace(/^-+|-+$/g, '');                        // trim -
  }

  function initReferenceFilters() {
    const page = document.querySelector('.page--references');
    if (!page) return;

    const filtersContainer = page.querySelector('.js-ref-filters');
    if (!filtersContainer) return;

    // On prend tous les blocs product-features dans cette page
    const cards = Array.from(page.querySelectorAll('.c-product-features'));
    if (!cards.length) return;

    const tagsMap = new Map(); // slug => label

    cards.forEach((card) => {
      const tagEls = card.querySelectorAll('.c-product-features__tag');
      const localSlugs = [];

      tagEls.forEach((el) => {
        const label = (el.textContent || '').trim();
        if (!label) return;

        const slug = slugify(label);
        if (!slug) return;

        localSlugs.push(slug);

        if (!tagsMap.has(slug)) {
          tagsMap.set(slug, label);
        }
      });

      if (localSlugs.length) {
        card.classList.add('js-ref-card');
        card.setAttribute('data-tags', localSlugs.join(' '));
      }
    });

    // Si aucun tag trouvé, on arrête
    if (!tagsMap.size) return;

    const refCards = Array.from(page.querySelectorAll('.js-ref-card'));
    if (!refCards.length) return;

    // ---------------- Boutons de filtre ----------------
    function createFilterButton(slug, label) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'c-ref-filter-btn';
      btn.setAttribute('data-filter', slug);
      btn.textContent = label;
      return btn;
    }

    // "Tous les projets"
    const allBtn = createFilterButton('*', 'Tous les projets');
    allBtn.classList.add('is-active');
    filtersContainer.appendChild(allBtn);

    // Boutons par tag
    tagsMap.forEach((label, slug) => {
      const btn = createFilterButton(slug, label);
      filtersContainer.appendChild(btn);
    });

    function setActiveButton(btn) {
      filtersContainer
        .querySelectorAll('.c-ref-filter-btn')
        .forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    function applyFilter(slug) {
      refCards.forEach((card) => {
        if (slug === '*') {
          card.hidden = false;
          return;
        }
        const tagsAttr = (card.getAttribute('data-tags') || '').trim();
        const tags = tagsAttr ? tagsAttr.split(/\s+/) : [];
        card.hidden = !tags.includes(slug);
      });
    }

    filtersContainer.addEventListener('click', (e) => {
      const btn = e.target.closest('.c-ref-filter-btn');
      if (!btn) return;

      const slug = btn.getAttribute('data-filter') || '*';
      setActiveButton(btn);
      applyFilter(slug);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReferenceFilters);
  } else {
    initReferenceFilters();
  }
})();
